import React, { Fragment } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import ShowDoc from '../../../../containers/CMDashboard/ShowDoc';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

const DocShowSection = ({
  fileRef,
  fileDivWidth,
  pdfloading,
  signedUrl,
  setShowDocSection,
  setTransactionWidth
}) => {
  return (
    <div
      className="w-full md:w-5/12 text-center mx-auto block "
      ref={fileRef}
      style={{ width: fileDivWidth }}
    >
      {!pdfloading && !signedUrl && (
        <div className="table mx-auto mt-10">
          <p className="text-center text-black-500 text-sm font-roboto mt-10">
            No PDF or Image specified!
          </p>
          <button
            type="button"
            onClick={() => {
              setShowDocSection(false);
              setTransactionWidth('100%');
            }}
            className="border border-black-500 px-2 rounded bg-blue-1101 text-white font-roboto text-sm"
          >
            close
          </button>
        </div>
      )}
      {pdfloading && <CircularProgress />}
      {signedUrl && (
        <Fragment>
          <div className="table ml-auto float-right clear-both mr-3 cursor-pointer">
            <HighlightOffIcon
              onClick={() => {
                setShowDocSection(false);
                setTransactionWidth('100%');
              }}
            />
          </div>
          <ShowDoc
            file={signedUrl}
            autoCheck={true}
            isShowninPopup={false}
            pageStyle={{
              minHeight: '95vh',
              marginTop: '10px'
            }}
            docContainerStyle={{ maxHeight: '100vh' }}
            fileTitleContainerStyle={{ marginTop: '0' }}
            fileTitleStyle={{ marginBottom: '0' }}
            docContainerClasses="text-center bg-black-1014 rounded-md  overflow-auto"
            loadingComponent={<CircularProgress />}
          />
        </Fragment>
      )}
    </div>
  );
};

export default React.memo(DocShowSection);
